import React, { useEffect, useState, useRef } from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";
import "./App.css";
import "./css/style.css";
import "./css/bootstrap.css";
import { cowBreedAboutMap, buffaloBreedAboutMap } from "./breeds";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
// Defaults used when API data is not available
const getCowImage = (breed, apiImage) => {
  // API image priority
  if (apiImage && apiImage !== "null") return apiImage;

  // Try breed image
  if (breed) {
    const formattedBreed = breed.trim();
    return `/img/breeds/${formattedBreed}.jpg`;
  }

  // final fallback
  return "/img/breeds/Dummy.png";
};


const DEFAULT_COWS = [
  {
    id: 1,
    name: "Cow",
    regNo: "-",
    breed: "-",
    dob: "-",
    about: "",
    health: "",
    farmer: "",
    img: "img/c1-min.png",
  },
  {
    id: 2,
    name: "Cow",
    regNo: "-",
    breed: "-",
    dob: "-",
    about: "",
    health: "",
    farmer: "",
    img: "img/c2-min.png",
  },
];

function truncate(text, limit = 220) {
  return text.length > limit ? text.slice(0, limit) + "..." : text;
}
// identify the breed
function getAboutText(animal) {
  const template =
    cowBreedAboutMap[animal.breed] || buffaloBreedAboutMap[animal.breed];

  if (!template) {
    return "Learn more about the animals that provide your milk.";
  }

  return template
    .replaceAll("{name}", animal.name || "our animal")
    .replaceAll(
      "{farmer}",
      animal.farmerObj?.farmerName || "our trusted farmer",
    );
}

const MeetOurCows = () => {
  const { cowsData, loading, errors } = useTraceabilityData();
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [activeTabByCowIndex, setActiveTabByCowIndex] = useState([
    "health",
    "health",
  ]);
  const moreCowsScrollRef = useRef(null);

  // Extract data from context
  const cowsFromApi = cowsData?.mappedCows || [];
  const collectionDescription = cowsData?.description || "";
  const isLoading = loading.cows;
  const loadError = errors.cows || "";
  const [showLoader, setShowLoader] = useState(true);

  const handleTabChange = (cowIndex, tabName) => {
    const updatedTabs = [...activeTabByCowIndex];
    updatedTabs[cowIndex] = tabName;
    setActiveTabByCowIndex(updatedTabs);
  };

  const nextSlide = () => {
    const length = displayCows.length + 1; // +1 for View All
    if (length === 0) return;
    setCurrentSlideIndex((prev) => (prev + 1) % length);
  };

  const prevSlide = () => {
    const length = displayCows.length + 1; // +1 for View All
    if (length === 0) return;
    setCurrentSlideIndex((prev) => (prev - 1 + length) % length);
  };


  // Horizontal scroll ref for "More Cows"

  // Optional: select cow from "More Cows"
  const handleCowSelect = (cow) => {
    alert(`Selected: ${cow.name}`);
  };

  // Update active tabs when cows data changes
  useEffect(() => {
    if (cowsFromApi.length > 0) {
      setActiveTabByCowIndex(cowsFromApi.map(() => "health"));
    }
  }, [cowsFromApi.length]);

  // const displayCows = cowsFromApi.length ? cowsFromApi : DEFAULT_COWS;

  // show only first 10 cows in first page slider
  const displayCows =
    cowsFromApi.length > 0
      ? cowsFromApi.slice(0, 10)
      : DEFAULT_COWS;


  const normalize = (value) =>
    value === null || value === undefined || value === "null" || value === ""
      ? "None"
      : String(value);
  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        setShowLoader(false);
      }, 1500); // ⏱️ adjust time (ms)

      return () => clearTimeout(timer);
    }
  }, [isLoading]);
  if (showLoader) {
    return (
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "40px" }}
      >
        <DotLottieReact
          src="https://lottie.host/f8f55ce4-6a3c-4220-8585-4ffb195baa86/nCJAJ8wm36.lottie"
          loop
          autoplay
        />
      </div>
    );
  }

  return (
    <div className="">
      <div className="wrapper2">
        <h2 className="heading2">Meet Our Cattle</h2>
      </div>

      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {isLoading && "Loading cows…"}
                {!isLoading && loadError && loadError}
                {!isLoading &&
                  !loadError &&
                  (collectionDescription ||
                    "Each cattle is like family to us, with her own unique ID that tracks her every step. We make sure her health, vaccinations, and calving are all carefully followed. Our vets treat her like their own, ensuring she’s happy and healthy. Every part of her journey contributes to the milk you enjoy. To us, she’s not just a cattle—she’s the heart of everything we do.")}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Cow Slider */}
      <div
        className="cw-slider-container"
        style={{ paddingTop: "29px", overflow: "hidden", position: "relative" }}
      >
        <div
          className="cw-slider"
          style={{
            display: "flex",
            transition: "transform 0.5s ease",
            transform: `translateX(-${currentSlideIndex * 100}%)`,
            // width: `${displayCows.length * 100}%`,
            width: "1005",
          }}
        >
          {displayCows.map((cow, index) => (
            <div
              key={cow.id}
              className="cw-container"
              style={{ flex: "0 0 100%", maxWidth: "100%" }}
            >
              {/* Image */}
              <div className="cw-image-section">
                <div className="cw-image-overlay"></div>
                <img
                  src={getCowImage(cow.breed, cow.img)}
                  alt={cow.name}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/breeds/Dummy.png";
                  }}
                />




              </div>

              {/* Content */}
              <div className="cw-content">
                <div className="cw-details">
                  <h2>{cow.name}</h2>
                  {/* <p>Cattle Registration No: {cow.regNo}</p> */}
                  <p>
                    Breed: {cow.breed} | DOB: {cow.dob}
                  </p>
                </div>

                {/* Tabs */}
                <div
                  className="cw-tabs"
                  role="tablist"
                  aria-label="Cow details tabs"
                >
                  <button
                    className={`cw-tab ${activeTabByCowIndex[index] === "health" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange(index, "health")}
                    role="tab"
                    aria-selected={activeTabByCowIndex[index] === "health"}
                  >
                    Health Details
                  </button>
                  <button
                    className={`cw-tab ${activeTabByCowIndex[index] === "farmer" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange(index, "farmer")}
                    role="tab"
                    aria-selected={activeTabByCowIndex[index] === "farmer"}
                  >
                    Farmer Details
                  </button>
                  <button
                    className={`cw-tab ${activeTabByCowIndex[index] === "about" ? "active" : ""
                      }`}
                    onClick={() => handleTabChange(index, "about")}
                    role="tab"
                    aria-selected={activeTabByCowIndex[index] === "about"}
                  >
                    About
                  </button>
                </div>

                {/* Tab Content */}
                <div className="cw-tab-content">
                  {activeTabByCowIndex[index] === "about" && (
                    <p
                      style={{
                        maxHeight: "80px",
                        overflowY: "auto",
                        margin: 0,
                      }}
                    >
                      {getAboutText(cow)}
                    </p>
                  )}
                  {activeTabByCowIndex[index] === "health" &&
                    (cow.healthObj ? (
                      <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                        <li>
                          <span style={{ fontWeight: 600 }}>Vaccinated:</span>{" "}
                          {normalize(cow.healthObj.vaccinated)}
                        </li>
                        <li>
                          <span style={{ fontWeight: 600 }}>Dewormed:</span>{" "}
                          {normalize(cow.healthObj.dewormed)}
                        </li>
                        <li>
                          <span style={{ fontWeight: 600 }}>Last Checkup:</span>{" "}
                          {normalize(cow.healthObj.lastCheckup)}
                        </li>
                      </ul>
                    ) : (
                      <p>Details not available.</p>
                    ))}
                  {activeTabByCowIndex[index] === "farmer" &&
                    (cow.farmerObj ? (
                      <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                        <li>
                          <span style={{ fontWeight: 600 }}>Farmer Name:</span>{" "}
                          {normalize(cow.farmerObj.farmerName)}
                        </li>
                        <li>
                          <span style={{ fontWeight: 600 }}>Farmer At:</span>{" "}
                          {normalize(cow.farmerObj.farmerAt)}
                        </li>
                      </ul>
                    ) : (
                      <p>Details not available.</p>
                    ))}
                </div>
              </div>
            </div>
          ))}
          {/* 11th Slide — View All */}
          <div
            className="cw-container"
            style={{
              flex: "0 0 100%",
              maxWidth: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Link
              to="/meet-our-cows-2"
              className="text-xl bg-[#4c922b] text-white py-6 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline mx-10"
            >
              View all Cows
            </Link>

          </div>
        </div>

        {/* Navigation Buttons */}
      </div>
      <div
        className="cw-nav-buttons-outside"
        style={{
          display: "flex",
          justifyContent: "center", // center buttons
          gap: "10px", // spacing between them
          marginTop: "20px",
        }}
      >
        <button className="cw-nav-btn" onClick={prevSlide}>
          &#9665;
        </button>
        <button className="cw-nav-btn" onClick={nextSlide}>
          &#9655;
        </button>
      </div>

      {/* More Cows Horizontal Slider */}
      <div className="bg-light mt-4">
        <div className="container p-3">
          <div className="underline2 my-3"></div>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <h5 className="m-0">More Cows</h5>
            <Link
              to="/meet-our-cows-2"
              style={{ color: "#333", fontSize: "15px" }}
            >
              View all
              <i
                className="icofont-rounded-right"
                style={{ color: "#4c922b" }}
              ></i>
            </Link>
          </div>

          <div className="position-relative">
            <div
              className="d-flex overflow-x-auto hide-scrollbar"
              ref={moreCowsScrollRef}
              style={{ gap: "12px", padding: "10px" }}
            >
              {[...displayCows].map((cow) => (
                <div
                  key={cow.id}
                  className="shop-item flex-shrink-0"
                  style={{ width: "62px", cursor: "pointer" }}
                  onClick={() => handleCowSelect(cow)}
                >
                  <div className="card bg-transparent border-0 text-center">
                    <img
                      src={getCowImage(cow.breed, cow.img)}
                      alt={cow.name}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/img/breeds/Dummy.png";
                      }}
                      className="card-img-top mb-2"
                      style={{
                        width: "62px",
                        height: "60px",
                        borderRadius: "8px",
                        objectFit: "cover",
                      }}
                    />
                    <div className="card-body p-0">
                      <p className="card-title m-0">{cow.name}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="bg-light" style={{ marginTop: "-20px" }}>
        <div className="container p-3">
          <div className="underline2 my-3 mx-1"></div>

          <h6 className="card-title fw-bold my-2 mx-1">Dairy Farm Insights</h6>


          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">
            <a href="meet-our-cows">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box1.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Meet Our
                      <br /> Cattle
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="meet-the-farmers">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box2.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Meet Our
                      <br /> Farmers
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="sustanibilty-in-dairy-farm">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box3.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Sustainability in Dairy Farms
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="open-housing-farm">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box4.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "12px" }}>
                      Learn About Open House Farming
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="farm-improvement-services">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box5.png" alt="" className="card-img-top" />
                  <div
                    className="position-absolute text-overlay-f text-white p-3"
                    style={{ top: "30%" }}
                  >
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Farm Improvement Services
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="smart-farming">
              <div className="product-item col">
                <div className="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/f-box6.png" alt="" className="card-img-top" />
                  <div className="position-absolute text-overlay-f text-white p-3">
                    <h6 className="fw-normal" style={{ fontSize: "13px" }}>
                      Smart Farming
                    </h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}

      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/dairy-farm"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/meet-the-farmers"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>
      </div>
    </div>
  );
};

export default MeetOurCows;
